<template>
  <v-layout class="mb-3" justify-center>
    <v-flex xs12 sm8 md6>
      <v-text-field
        v-model="search"
        append-icon="search"
        clearable
        @click:clear="search = ''"
        hide-details
        label="Buscar una marca por nombre"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("matching");

export default {
  computed: {
    ...mapState(["brandsSearch"]),
    classificationId() {
      return this.$route.params.classificationId;
    },
    search: {
      get() {
        return this.brandsSearch;
      },
      set(value) {
        this.setBrandsSearch(value);
      }
    }
  },
  methods: {
    ...mapMutations(["setBrandsSearch"])
  }
};
</script>